const LoadState = {
	INIT: "INIT",
	LOADING: "LOADING",
	LOADED: "LOADED",
	ERROR: "ERROR"
};
export default LoadState;
